import { render } from "./KanalK.vue?vue&type=template&id=c609dbee"
import script from "./KanalK.vue?vue&type=script&lang=js"
export * from "./KanalK.vue?vue&type=script&lang=js"

import "./KanalK.vue?vue&type=style&index=0&id=c609dbee&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__